import React from "react"
import { Outlet, type RouteObject } from "react-router"
import AuthenticatedRoute from "src/components/authenticated-route"
import { routeNames } from "src/router/route-names"

export const createEconsentPdfRoutes = (): RouteObject[] => {
  return [
    {
      path: routeNames.econsentPdfEditor.route,
      lazy: () => import("src/pages/econsent-pdf/editor/page"),
    },
    {
      path: routeNames.econsentPdfEditorPreview.route,
      lazy: () =>
        import("src/pages/econsent-pdf/viewer/preview/editor-preview-page"),
    },
    {
      path: routeNames.econsentPdfPreview.route,
      lazy: () =>
        import("src/pages/econsent-pdf/viewer/preview/global-preview-page"),
    },
    {
      element: (
        <AuthenticatedRoute>
          <Outlet />
        </AuthenticatedRoute>
      ),
      children: [
        {
          path: routeNames.econsentPdfViewer.route,
          lazy: () => import("src/pages/econsent-pdf/viewer/page"),
        },
        {
          path: routeNames.inPersonEconsentPdfViewer.route,
          lazy: () => import("src/pages/econsent-pdf/viewer/page"),
        },
      ],
    },
  ]
}
